/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserProfileActiveTenantResponse {
    getFixupPrototypeFunction() { return UserProfileActiveTenantResponse.fixupPrototype; }

    static newInstance(model: Partial<UserProfileActiveTenantResponse>): UserProfileActiveTenantResponse {
        let obj = Object.assign(new UserProfileActiveTenantResponse(), model);
        UserProfileActiveTenantResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserProfileActiveTenantResponse>): UserProfileActiveTenantResponse {
        if (!model) return null;
        return UserProfileActiveTenantResponse.newInstance(<UserProfileActiveTenantResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserProfileActiveTenantResponse) {
        if (!obj) return;

        models.UserProfileActiveTenantResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserProfileActiveTenantResponse): boolean {
        Object.setPrototypeOf(obj, UserProfileActiveTenantResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID for user that was updated
     */
    id: string;

    /**
     * ID for the new active tenant
     */
    tenant_id: string;

}
